module.exports = __webpack_public_path__ + "static/img/rank_130.177b0d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_130.png
// module id = +Sar
// module chunks = 1